export default "__VITE_ASSET__2c045cfe__"